import { useDispatch } from "react-redux";
import Xarrow from "react-xarrows";
import { importFromYaml } from "../../../../abstract/controller/modelYamlImport";
import * as tutorialUtils from "../../../../abstract/controller/utils/tutorialUtils";
import { useArrowSync } from "../../../../abstract/hook/useArrowSync";
import { setRoot } from "../../../../abstract/redux/slice/structureSlice";
import ButtonIntroWide from "../../../ui/buttons/ButtonIntroWide";
import ButtonTomatoClose from "../../../ui/buttons/ButtonTomatoClose";
import styles from "./Manual.module.scss";

const id = "dNT1";
const idNext = "dNT2";

const next = `
functions:
  - function: Demo
`;

function ManualDedicatedNorskTipping1({ tutorial, setTutorial }) {
  if (tutorial === id) {
    return <Core setTutorial={setTutorial} />;
  }

  return null;
}

function Core({ setTutorial }) {
  const _dispatch = useDispatch();
  const renderTrigger = useArrowSync();

  const handleShowMe = () => {
    const { model } = importFromYaml(next);
    _dispatch(setRoot(model, 0));
  };

  const handleClose = () => {
    setTutorial("null");
  };

  return (
    <>
      {document.getElementById("group_function") && (
        <div className={`${styles["container"]} ${styles["container-dnt1"]} ${styles["overlay"]}`}>
          <div id="tutorial-text-1a" className={`${styles["container__text"]}`}>
            <p>This sidebar lists all functions within your current model.</p>
            <p>
              Click on the default function and change its name to <b>Demo</b>.
            </p>
          </div>

          <Xarrow
            key={`arrow-1-${renderTrigger}`}
            start="tutorial-text-1a"
            end="group_function"
            color="#415B32"
            strokeWidth={2}
            path="smooth"
            curveness={0.5}
            headSize={6}
          />
        </div>
      )}

      <div className={`${styles["foreground"]} ${styles["foreground-dnt1"]}  ${styles["overlay"]}`}>
        <ButtonTomatoClose onClick={handleClose} />
        <div className={styles["header"]}>
          <div className={styles["header__assistant"]}></div>
          <div className={styles["header__text--main"]}>
            <p>
              In this tutorial, you'll learn how to build a simple model and generate tests. Models
              are organized into functions, which contain parameters and logic.
            </p>
            <p>
              First, change the name of the default function to <b>Demo</b>.
            </p>
          </div>
        </div>
        <div className={styles["confirmation"]}>
          <div className={styles["button"]}>
            <ButtonIntroWide theme="tomato" title="Show me!" onClick={handleShowMe} />
          </div>
        </div>
      </div>
    </>
  );
}

export const manualValidateDedicatedNorskTipping1 = (root, tutorial, setTutorial, setMessage) => {
  if (tutorial === id) {
    let { res, msg } = tutorialUtils.validateSingleFunction(root, "Demo");

    if (!res) {
      setMessage(msg)
      return false;
    }

    setTutorial(idNext);

    setMessage("")
    return true;
  }

  return false;
};

export default ManualDedicatedNorskTipping1;
